import {NgModule}                       from '@angular/core';
import {CommonModule}                   from '@angular/common';
import {ApDynComponentModule}           from '../ap-dyncomponent/ap-dyncomponent.module';
import {PDFExportModule}                from '@progress/kendo-angular-pdf-export';
import {ApIconModule}                   from '../icons/ap-icon.module';
import {ApTranslationModule}            from '../translation/ap-translation.module';
import {ApMapModule}                    from '../map/ap-map.module';
import {ApUtilsModule}                  from '../ap-utils';
import {ApFarmRecordsOverviewComponent} from './components/ap-farm-records-overview.component';
import {ApFarmRecordsRoutes}            from './ap-farm-records.routes';
import {ApSectionHeaderModule}          from '../ap-section-header/ap-section-header.module';
import {ApPermissionModule}             from '../ap-permission/ap-permission.module';

@NgModule({
  declarations: [ApFarmRecordsOverviewComponent],
  exports: [ApFarmRecordsOverviewComponent],
  imports: [
    CommonModule,
    ApFarmRecordsRoutes,
    ApDynComponentModule,
    PDFExportModule,
    ApIconModule,
    ApTranslationModule,
    ApMapModule,
    ApUtilsModule,
    ApSectionHeaderModule,
    ApPermissionModule
  ],
  providers: []
})
export class ApFarmRecordsModule {
}
